export default __webpack_public_path__ + "static/media/email-icon.d4ce3ff4.svg";